module.exports = __webpack_public_path__ + "img/collection-diamondJewelryRedgold@2x.92784bf.webp";